import React from "react";

function MailIcon({ fill = "#707070" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.919"
      height="14.482"
      viewBox="0 0 20.919 14.482"
    >
      <g
        id="Icon_ionic-ios-mail"
        data-name="Icon ionic-ios-mail"
        transform="translate(-3.375 -7.875)"
      >
        <path
          id="Path_1885"
          data-name="Path 1885"
          d="M24.123,10.345l-5.411,5.511a.1.1,0,0,0,0,.141L22.5,20.03a.653.653,0,0,1,0,.925.656.656,0,0,1-.925,0L17.8,16.937a.1.1,0,0,0-.146,0l-.92.935A4.049,4.049,0,0,1,13.85,19.09,4.13,4.13,0,0,1,10.9,17.837l-.885-.9a.1.1,0,0,0-.146,0L6.1,20.955a.656.656,0,0,1-.925,0,.653.653,0,0,1,0-.925L8.962,16a.107.107,0,0,0,0-.141L3.546,10.345a.1.1,0,0,0-.171.07V21.443a1.614,1.614,0,0,0,1.609,1.609h17.7a1.614,1.614,0,0,0,1.609-1.609V10.415A.1.1,0,0,0,24.123,10.345Z"
          transform="translate(0 -0.695)"
          fill={fill}
        />
        <path
          id="Path_1886"
          data-name="Path 1886"
          d="M14.077,17.082a2.734,2.734,0,0,0,1.966-.825l7.89-8.031a1.58,1.58,0,0,0-1-.352H5.221a1.57,1.57,0,0,0-1,.352l7.89,8.031A2.734,2.734,0,0,0,14.077,17.082Z"
          transform="translate(-0.242)"
          fill={fill}
        />
      </g>
    </svg>
  );
}

export default MailIcon;
